import { TabWrap } from 'sections/TabWrap';

import { useCategories } from './Categories.hooks';

export function Categories(): React.ReactElement {
  const { sections } = useCategories();

  return <TabWrap sections={sections} />;
}
